import { Controller } from "@hotwired/stimulus"

// Pre-fills a class picker with the classes that follow a set of periods
// (evaluation calendar) that year: choosing « Anglophone (terms) » ticks
// exactly the classes on that calendar. The ticks stay editable afterwards.
//
// Checkboxes carry `data-period-set-id` (empty when the class follows no set).
export default class extends Controller {
  static targets = ["set", "checkbox"]

  prefill() {
    const chosen = this.setTarget.value
    if (!chosen) return

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = (checkbox.dataset.periodSetId || "") === chosen
    })
  }
}
